// #region IMPORTS
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

import type { BonesMap, EnhancedGLTF } from '@cartwhl/3d/gltf/types';
import type { Character } from '@cartwhl/common/api/getCharacters';

// #endregion

export async function downloadCharacter(
  char: Character,
): Promise<EnhancedGLTF> {
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Load character mesh
  const loader = new GLTFLoader();
  loader.setWithCredentials(true);

  const gltf = await loader.loadAsync(char.meshPath);

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Load bones map file
  const bonesPath = char.meshPath.replace('.glb', '.json');
  let bonesMap: BonesMap = {};
  try {
    const res = await fetch(bonesPath, { credentials: 'include' });
    if (res.ok) bonesMap = (await res.json()).joints;
  } catch (err) {
    // No bones map found
  }

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // Update State
  const out: EnhancedGLTF = {
    ...gltf,
    nodes: {},
    materials: {},
    meshes: {},
    bonesMap,
  };

  char.readyOn = new Date();
  char.meshData.current = out;

  return out;
}
